import { addToBasket, basketChangeFetch, userLoggedIn } from "../cookies.js"
import { customSelect, customInput } from "./customComponents.js"

export let dataAPI = []

export async function getCategories() {
    const category = document.querySelector('#category-choose')

    if (!category) return

    let dataCategories = await fetch('/api/calculete-category/', {
        method: 'GET'
    })
    if (dataCategories.ok) {
        dataCategories = await dataCategories.json()
        renderOptionsInSelect(category, dataCategories.results)
    } else {
        console.error(dataCategories);
    }
}

function renderOptionsInSelect(container, data) {
    const optionContainer = container.querySelector('.custom-select__body')
    optionContainer.innerHTML = ``
    let template = ``
    data.forEach(el => {
        template = template + 
        `<div data-id="${el.id}" class="option">${el.name}</div>`
    })
    optionContainer.insertAdjacentHTML('afterbegin', template) 

    customSelect()
}

export async function getProducts(id) {

    const product = document.querySelector('#product-choose')

    console.log(id)

    const url = `/api/calculete-category/${id}/details/`
    let dataProducts = await fetch(url, {
        method: 'GET'
    })
    if (dataProducts.ok) {
        dataProducts = await dataProducts.json()
        console.log(dataProducts)
        renderOptionsInSelect(product, dataProducts.products)
        
        dataAPI = dataProducts.products

        // getFieldsProduct(id, dataProducts.products)
    }
}

export async function getFieldsProduct(id) {
    
    const containerSelect = document.querySelector('.calculate-block__inputs__custom')
    containerSelect.innerHTML = ``

    const activeProduct = dataAPI.find(prod => prod.id == id)

    const container = document.querySelector('.calculate-block__inputs__custom')

    const item = `
        <label for="input" class="custom-input">
            <span class="placeholder">Площадь нанесения, м²</span>
            <input id="input" type="number">
        </label>
    `

    container.insertAdjacentHTML('beforeend', item)

    customInput()

    for (let coff of activeProduct.coefficients) {
        // console.log(`вывожу коэфиценты - ${coff.name}`)
        // console.log(coff);
        createSelect(coff.name, coff.coefficients)
    }
}

function createSelect(placeholder, options = []) {

    const container = document.querySelector('.calculate-block__inputs__custom')
    let templateOption = ``
    for (let option of options) {
        console.log(option)
        templateOption = templateOption + 
            `<div data-id="${option.id}" class="option">${option.name}</div>`
    }

    let item = `
        <div class="custom-select" data-storage="coff">
            <div class="custom-select__header">
                <span class="placeholder">${placeholder}</span>
                <span class="value"></span>
                <div class="custom-select__chevron">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="outlined / chevron-down">
                        <path id="Icon" d="M6 9L12 15L18 9" stroke="#1C1917" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                    </svg>
                </div>
            </div>
            <div class="custom-select__body">
                ${templateOption}
            </div>
        </div>
    `

    container.insertAdjacentHTML('beforeend', item)   
    customSelect()
}

export function calculate() {

    const mainContainer = document.querySelector('.calculate-block')
    if (!mainContainer) return
    const button = mainContainer.querySelector('.calculate')
    
    const deleteButton = mainContainer.querySelector('.delete')

    if (!mainContainer) return
    
    button.onclick = () => {
        checkSelect(mainContainer)
    }

    deleteButton.onclick = () => {
        const category = document.querySelector('#category-choose')
        const product = document.querySelector('#product-choose')

        category.querySelector('.value').textContent = ``
        product.querySelector('.value').textContent = ``
        
        category.querySelector('.placeholder').classList.remove('top-placeholder')
        product.querySelector('.placeholder').classList.remove('top-placeholder')

        const containerSelect = document.querySelector('.calculate-block__inputs__custom')
        containerSelect.innerHTML = ``

        hideBlocks(true);
    }
}

function checkSelect(mainContainer) {
    let error = false
    let dataSelect = []
    
    const selects = mainContainer.querySelectorAll('.custom-select')
    const inputContainer = document.querySelector('.custom-input')
    const input = inputContainer.querySelector('input')


    selects.forEach(el => {
        const value = el.querySelector('.value')

        // получаю id а не само значение
        dataSelect.push(value.getAttribute('data-id'))

        if (value.textContent == '') {
            el.classList.add('error-select')
            error = true
        } else if (el.classList.contains('error-select')) {
            el.classList.remove('error-select')
        }
    })

    if (input.value == '') {
        console.log('complete')
        inputContainer.classList.add('error-input')
        error = true
    } else {
        inputContainer.classList.remove('error-input')
    }

    if (!error) {
        sendInfo(input.value, dataSelect)
    }
}

async function sendInfo(metrs, data=[]) {
    let id = sessionStorage.getItem('product');
    let url = `/api/calculete-products/${id}/calculate/?area=${metrs}&coefficients=`
    let newData = data.slice(2)
    
    for (let data of newData) {
        url = url + data + `,`
    }
    
    url = url.replace(/,$/, "")

    let dataApi = await fetch(url, { method: 'GET' })
    dataApi = await dataApi.json()

    let dataProduct = await fetch(`/api/calculete-products/${id}/`)
    dataProduct = await dataProduct.json()

    blockInfo(dataProduct, dataApi);
}

function blockInfo(dataProduct, dataInfo) {

    hideBlocks(false);

    Object.entries(dataProduct).map(([key, value])=>{
        const block = document.querySelector(`[data-product="${key}"]`);
        if(!block) return;
        switch (key) {
            case 'slug':
                block.href = `/product/${value}`;
                break;
            case 'main_photo':
                block.src = `${value}`;
                break;
            default:
                block.innerHTML = value;
                break;
        }
    });
    Object.entries(dataInfo).map(([key, value])=>{
        const block = document.querySelector(`[data-info="${key}"]`);
        if(!block) return;
        switch (key) {
            case 'required_kg':
                block.innerHTML = `${parseFloat(value).toFixed(2)} кг`;
                break;
            default:
                block.innerHTML = value;
                break;
        }
    });

    const addBtn = document.querySelector('.__calculator_add_in_basket');

    addBtn.onclick=async()=>{
        if(userLoggedIn()) {
            await basketChangeFetch({
                product: dataProduct.id,
                quantity: dataInfo.required_packages
            }, 'add/', userLoggedIn())
        } else {
            await addToBasket(dataProduct.id, dataInfo.required_packages);
        };
        window.location.href = "/basket/";
    };
    
    const titleCategory = document.querySelector('#productCategory')
    
    const category = document.querySelector('#category-choose').querySelector('.value').textContent

    titleCategory.textContent = category
    
}

function hideBlocks(boolean) {
    const notDisplayed = document.querySelectorAll('.__not_displayed');
    Array.from(notDisplayed).map(item=>{
        if(boolean) {
            item.classList.add('none');
        } else {
            item.classList.remove('none');
        }
    });
    const hideInfo = document.querySelectorAll('.__hide_info');
    Array.from(hideInfo).map(item=>{
        if(boolean) {
            item.classList.remove('none');
        } else {
            item.classList.add('none');
        }
    });
}